// react
import React, { useEffect, useState } from 'react'

//hooks
import { useRetractSidebar } from '_hooks'

// components
import Header from '_components/header/index.jsx'
import Form from '_components/form/Form'
import toast from '@st-operations/uikit/lib/toast'

//service
import {
  getAPADataSourceById,
  getAPADataSourcesSchema,
  updateApaDataSource,
} from '_services/data-sources-apa'

//styles
import './styles.scss'

const DataSourceAPAPage = (props) => {
  const [dataSource, setDataSource] = useState({})
  const [samplingRateKeys, setSamplingRateKey] = useState([])
  const [schema, setSchema] = useState({})
  const [fields, setFields] = useState([])

  useRetractSidebar()

  useEffect(() => {
    fetchSchemaAndData()
  }, [])

  const onChange = (value, name) => {
    const updatedItem = {
      ...dataSource,
      [name]: value?.value || value,
    }
    setDataSource(updatedItem)
  }

  const onSave = async () => {
    try {
      const samplingRates = {}
      for (const key of samplingRateKeys) {
        samplingRates[key] = dataSource[key]
      }
      dataSource.samplingRates = samplingRates
      const results = updateApaDataSource(dataSource, props.match.params.id)
      if (results) {
        toast.success('successfully updated data source')
        window._history.push(`/data-sources-apa`)
      }
    } catch (error) {
      toast.error('Error while updating Data Source')
    }
  }

  const onCancel = () => {
    window._history.push(`/data-sources-apa`)
  }

  const fetchSchemaAndData = async () => {
    try {
      const calls = [getAPADataSourcesSchema(), getAPADataSourceById(props.match.params.id)]
      const results = await Promise.all(calls)
      if (results.length) {
        const schemaValues = results[0]
        const dataSourceResult = results[1]
        const dataSourceSchema = {
          name: schemaValues.name,
          index: schemaValues.index,
        }
        const srKeys = []
        for (const [key, value] of Object.entries(schemaValues.samplingRates.type)) {
          dataSourceSchema[key] = value
          srKeys.push(key)
        }
        const datSourceFields = Object.keys(dataSourceSchema).map((key) => {
          return { name: key }
        })
        setSchema(dataSourceSchema)
        setFields(datSourceFields)
        setDataSource(dataSourceResult)
        setSamplingRateKey(srKeys)
      }
    } catch (error) {
      toast.error('Error while fetching data source details')
    }
  }

  return (
    <div id="data-source-apa-page">
      <Header
        title={dataSource?.name}
        actions={[
          {
            children: 'Save',
            onClick: onSave,
          },
          {
            children: 'Cancel',
            onClick: onCancel,
          },
        ]}
      />
      <Form
        fields={fields}
        schema={schema}
        item={dataSource}
        onChange={onChange}
        className="datasource-form-container"
      />
    </div>
  )
}

export default DataSourceAPAPage
